import { DatePicker } from 'common/InputForm';
import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';

const SalesDetails = ({ weeklySales = [], input, setInput }) => {

  const [chartData, setChartData] = useState({
    series: [],
    options: {},
  });

  // -----------handle-Date-change---------------
  const handleDateChange = (name, date) => {
    setInput({ ...input, [name]: date })
  }

  useEffect(() => {
    // Clear chart when API returns empty array
    if (!weeklySales.length) {
      setChartData({ series: [], options: {} });
      return;
    }

    const seriesData = weeklySales.map(item => ({
      x: new Date(item._id).getTime(),
      y: item.total,
    }));

    setChartData({
      series: [{
        name: 'Sales',
        data: seriesData,
      }],
      options: {
        chart: {
          type: 'bar',
          height: 300,
          zoom: {
            enabled: true,
            type: 'x',
          },
          toolbar: {
            show: false,
            tools: {
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 6,
            columnWidth: '45%',
            endingShape: 'rounded',
          }
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeFormatter: {
              year: 'yyyy',
              month: 'MMM \'yy',
              day: 'dd MMM',
            }
          }
        },
        yaxis: {
          labels: {
            formatter: (val) => `${val}`
          }
        },
        colors: ['#ec407a'],
        title: {
          text: 'Sales Details',
          align: 'left',
          style: {
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#333',
          },
        },
        grid: {
          show: true,
          borderColor: '#f0f0f0',
        },
      },
    });
  }, [weeklySales]);

  return (
    <div className="col-md-6">
      <div className="card shadow-sm p-4">
        <div>
          <div className="form_field_wrap">
            <div className="form_field">
              <DatePicker
                name="startDate"
                label='Start Date'
                selected={input?.startDate}
                placeholder="Start Date"
                onChange={(date) => handleDateChange('startDate', date)}
                maxDate={input?.endDate}
                autoComplete="off"
              />
            </div>
            <div className="form_field">
              <DatePicker
                name="endDate"
                label='End Date'
                selected={input?.endDate}
                placeholder="End Date"
                onChange={(date) => handleDateChange('endDate', date)}
                minDate={input?.startDate}
                autoComplete="off"
              />
            </div>
          </div>
          <div id="chart">
            {chartData.series.length > 0 ? (
              <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type="bar"
                height={300}
              />
            ) : (
              <div
                style={{
                  height: '300px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#999',
                  fontSize: '14px',
                }}
              >
                No sales data available for the selected date range.
              </div>
            )}
          </div>
          <div id="html-dist"></div>
        </div>
      </div>
    </div>
  )
}

export default SalesDetails